module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"noEvents":"Keine Einträge","unknownUser":"System"}}')
  delete Component.options._Ctor
}
